import { render, staticRenderFns } from "./ListArticleList.vue?vue&type=template&id=01f4fb7a&scoped=true"
import script from "./ListArticleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticleList.vue?vue&type=style&index=0&id=01f4fb7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4fb7a",
  null
  
)

export default component.exports